/**
 * @desc  DataModificationLockService class.
 * @ngInject
 */
export default class DataModificationLockService {
  /**
   * Constructor of the class.
   *
   * @param {$rootScope} $rootScope
   * @param {$q} $q
   * @param {$log}  $log
   * @param {$http} $http
   */
  constructor(
    $rootScope, $q, $log, $http
  ) {
    this.$rootScope = $rootScope;
    this.$q = $q;
    this.$log = $log;
    this.$http = $http;
  }

  get() {
    return this.$http({
      method: 'GET',
      url: `/SCR/dataModificationLock/schoolCommonRoom/${this.$rootScope.me.schoolCommonRoomId}`
    }).then(({data} = {}) => {
      return this.$q.resolve(data);
    }, err => this.$q.reject(err));
  }
}
